import { render } from "./MutualSettlements.vue?vue&type=template&id=49196716&scoped=true"
import script from "./MutualSettlements.vue?vue&type=script&lang=js"
export * from "./MutualSettlements.vue?vue&type=script&lang=js"

import "./MutualSettlements.vue?vue&type=style&index=0&id=49196716&scoped=true&lang=css"

import exportComponent from "/Users/tin/Documents/asket/stone-xxi.ru-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49196716"]])

export default __exports__